var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5971 9.04123L12.1157 10.5702L8.04675 14.667L3.92158 10.5136L5.41237 9.01255L8.01898 11.637L10.5971 9.04123ZM5.41205 6.84943L3.99028 5.41792L8.04675 1.33366L12.0466 5.36096L10.5971 6.82042L8.01898 4.22464L5.41205 6.84943ZM6.42595 7.9402L7.96883 9.49365L9.51172 7.9402L7.96883 6.38674L6.42595 7.9402ZM2.87769 9.49333L1.3348 7.93987L2.87769 6.38641L4.42057 7.93987L2.87769 9.49333ZM11.5822 7.9402L13.1251 9.49365L14.668 7.9402L13.1251 6.38674L11.5822 7.9402Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.83c6fc4866a29df4ef005923899b913f.svg";
export { ForwardRef as ReactComponent };